// extracted by mini-css-extract-plugin
module.exports = {"frame":"CardFrame_frame__2UZpA","light":"CardFrame_light__1pEH2","dark":"CardFrame_dark__2piyE","accent":"CardFrame_accent__1Tjj4"};